import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentDocumentEditItem extends IEditItem {
    code: string;
    comment: string;
    content: string;
    version: number;
    contentVersion: number;
    publishVersion: number;
    publishedId: string;
    endDate: number;
    landscapeOrientation: boolean;
    keywordIds: string[];

    createUser: IModifyUser;
    modifyUser: IModifyUser;
    approveUser: IModifyUser;
    publishUser: IModifyUser;
    lockedUser: IModifyUser;

    isLockedToOtherUser(userCode: string): boolean;
}

export class DocumentDocumentEditItem extends EditItem implements IDocumentDocumentEditItem {
    code: string;
    comment: string;
    content: string;
    version: number;
    contentVersion: number;
    publishVersion: number;
    publishedId: string;
    endDate: number;
    landscapeOrientation: boolean;
    keywordIds: string[];

    createUser: ModifyUser;
    modifyUser: ModifyUser;
    approveUser: ModifyUser;
    publishUser: ModifyUser;
    lockedUser: ModifyUser;

    constructor();
    constructor(obj: IDocumentDocumentEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.content = obj && obj.content || "";
        this.version = obj && obj.version || 0;
        this.contentVersion = obj && obj.contentVersion || 0;
        this.publishVersion = obj && obj.publishVersion || 0;
        this.publishedId = obj && obj.publishedId || "";
        this.endDate = obj && obj.endDate || null;
        this.landscapeOrientation = obj && obj.landscapeOrientation || false;
        this.keywordIds = obj && obj.keywordIds || [];
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = null;
        if (obj.modifyUser) {
            this.modifyUser = new ModifyUser(obj.modifyUser);
        }
        this.approveUser = null;
        if (obj.approveUser) {
            this.approveUser = new ModifyUser(obj.approveUser);
        }
        this.publishUser = null;
        if (obj.publishUser) {
            this.publishUser = new ModifyUser(obj.publishUser);
        }
        this.lockedUser = null;
        if (obj.lockedUser) {
            this.lockedUser = new ModifyUser(obj.lockedUser);
        }
    }
    
    isLockedToOtherUser(userCode: string): boolean {
        return this.lockedUser?.code && !userCode.equalIgnoreCase(this.lockedUser.code);
    }
}